import { createSlice } from "@reduxjs/toolkit";

const info = sessionStorage.getItem("siteInfo")

const SiteInfoSlice = createSlice({
    name: 'siteInfo',
    initialState: info ? JSON.parse(info) : {},
    reducers: {
        setSiteInfo(state, { payload }) {
            const { logo, serverUrl, version, copyright, recordNumber } = payload
            state.logo = logo
            state.serverUrl = serverUrl
            state.version = version
            state.copyright = copyright
            state.recordNumber = recordNumber
            sessionStorage.setItem("siteInfo", JSON.stringify(payload))
        }
    }
})

// 导出action函数
export const { setSiteInfo } = SiteInfoSlice.actions


// 导出  reducer ， 创建store
export default SiteInfoSlice.reducer
